import { all, call, put, takeLatest } from "redux-saga/effects";
import routeGroupService from "../../services/routeGroupService";
import { routeGroupActions } from "../slices/routeGroupSlice";

function* getRouteGroupsSaga({ payload }) {
  try {
    const data = yield call(routeGroupService.getRouteGroups, payload.date);
    yield put(routeGroupActions.getRouteGroupsSuccess(data));
  } catch (e) {
    yield put(routeGroupActions.getRouteGroupsError(e.response.data));
  }
}

function* getForCopyRouteGroupsSaga({ payload }) {
  try {
    const data = yield call(
      routeGroupService.getForCopyRouteGroups,
      payload.date
    );
    yield put(routeGroupActions.getForCopyRouteGroupsSuccess(data));
  } catch (e) {
    yield put(routeGroupActions.getForCopyRouteGroupsError(e.response.data));
  }
}

function* createRouteGroupSaga({ payload }) {
  try {
    const data = yield call(routeGroupService.createRouteGroup, payload.obj);
    yield put(routeGroupActions.createRouteGroupSuccess());

    payload.onSucceededCreatedRouteGroup(data);
  } catch (e) {
    yield put(routeGroupActions.createRouteGroupError(e.response.data));
  }
}

function* updateRouteGroupSaga({ payload }) {
  try {
    const data = yield call(routeGroupService.updateRouteGroup, payload);
    yield put(routeGroupActions.updateRouteGroupSuccess());

    // payload.onSucceededCreatedRouteGroup(data);
  } catch (e) {
    yield put(routeGroupActions.updateRouteGroupError(e.response.data));
  }
}

function* addRouteRouteGroupSaga({ payload }) {
  try {
    yield call(routeGroupService.addRouteToRouteGroup, {
      payload: { routeId: payload.routeId },
      id: payload.id,
    });
    yield put(routeGroupActions.addRouteToRouteGroupSuccess());

    payload.onSucceededAddedRouteToRouteGroup();
  } catch (e) {
    yield put(routeGroupActions.addRouteToRouteGroupError(e.response.data));
  }
}

function* deleteRouteFromRouteGroupSaga({ payload }) {
  try {
    yield call(routeGroupService.deleteRouteFromRouteGroup, {
      payload: { routeId: payload.routeId },
      id: payload.id,
    });
    yield put(routeGroupActions.deleteRouteFromRouteGroupSuccess());

    payload.onSucceededDeletedRouteFromRouteGroup();
  } catch (e) {
    yield put(
      routeGroupActions.deleteRouteFromRouteGroupError(e.response.data)
    );
  }
}

function* deleteRouteGroupSaga({ payload }) {
  try {
    yield call(routeGroupService.deleteRouteGroup, payload.id);
    yield put(routeGroupActions.deleteRouteGroupSuccess());

    payload.onSucceededDeletedRouteGroup();
  } catch (e) {
    yield put(routeGroupActions.deleteRouteGroupError(e.response.data));
  }
}

function* copyRouteGroupToClipboardSaga({ payload }) {
  try {
    // Poziv API-ja
    const res = yield call(routeGroupService.copyRouteGroupToClipboard, {
      date: payload.date,
      routeGroupId: payload.id,
    });

    console.log("Data received for clipboard:", res);

    // Dispatch success sa celim response
    yield put(routeGroupActions.copyRouteGroupToClipboardSuccess(res));

    // Poziv callback-a iz payload-a
    if (payload.onSucceededCopyRouteGroupToClipboard) {
      payload.onSucceededCopyRouteGroupToClipboard(res);
    }
  } catch (e) {
    console.error("Error in copyRouteGroupToClipboardSaga:", e);

    // Sigurno čitanje errora
    const errorPayload = e.response?.data || {
      message: e.message || "Unknown error",
    };
    yield put(routeGroupActions.copyRouteGroupToClipboardError(errorPayload));
  }
}

export default function* routeGroupSaga() {
  yield all([
    takeLatest("routeGroup/createRouteGroupPost", createRouteGroupSaga),
    takeLatest("routeGroup/getRouteGroupsFetch", getRouteGroupsSaga),
    takeLatest(
      "routeGroup/getForCopyRouteGroupsFetch",
      getForCopyRouteGroupsSaga
    ),
    takeLatest("routeGroup/updateRouteGroupPut", updateRouteGroupSaga),
    takeLatest("routeGroup/addRouteToRouteGroupPut", addRouteRouteGroupSaga),
    takeLatest(
      "routeGroup/deleteRouteFromRouteGroupPut",
      deleteRouteFromRouteGroupSaga
    ),
    takeLatest("routeGroup/deleteRouteGroupDelete", deleteRouteGroupSaga),
    takeLatest(
      "routeGroup/copyRouteGroupToClipboard",
      copyRouteGroupToClipboardSaga
    ),
  ]);
}
